module.exports = __webpack_public_path__ + "img/云稼田头市场-太阳码.196b6a71.jpg";